
import { get, patch } from "./api";

const BASE_URL = "/api/v2/customers";

export const getAllocation = async (customerId) => {
 const url =`${BASE_URL}/${customerId}/saas-target-allocation/`;
  return get(url);
};

export const patchAllocation = async (customerId, payload) => {
  const url =`${BASE_URL}/${customerId}/saas-target-allocation/`;
  return patch(url, payload);
};